import Block from './Block'

export default class SliderHouses extends Block {
    constructor(blockRoot) {
        super(blockRoot)
        this.statusPlaceholders = this.root.find('.slide__info__status.placeholder')

        this.root.find('.slider').slick({
            arrows: true,
            prevArrow: '<div type="button" class="slick-prev"><i class="fa fa-chevron-left fa-5x" aria-hidden="true"></i></div>',
            nextArrow: '<div type="button" class="slick-next"><i class="fa fa-chevron-right fa-5x" aria-hidden="true"></i></div>',
        })

        let wpids = this.statusPlaceholders.toArray().map(p => $(p).data('property-wpid'))

        $.ajax({
            method: 'POST',
            url: window.wpEnvironment.ajaxurl,
            data: {
                action: 'getMultiplePropertyVisningStatus',
                wpids: wpids,
                proptype: 'projekt',
            },
            success: data => {
                if (data.success && data.payload !== 'undefined' && data.payload.dates instanceof Array) {
                    this.statusPlaceholders.each((i, p) => {
                        $(p).before(data.payload.dates[i])
                        $(p).remove()
                    })
                }
            },
            complete: (jqXHR) => {
                // console.log(jqXHR);
            },
        })

    }
}
